import TopBar from "../components/topbar/TopBar";
import Leftbar from "../components/leftbar/Leftbar";
import { Outlet } from "react-router-dom";
import { usePreserveLocalStorage } from "../hooks/usePreserveLocalStorage";

const MainLayout = () => {
  usePreserveLocalStorage();
  return (
    <div className="flex h-[100vh] w-[100vw]">
      <div className="w-[18%] h-[100vh]">
        <Leftbar />
      </div>
      <div className="w-[82%] h-[100vh]">
        <div className="h-[80px] border-b-[1px] border-[#d3d3d3]">
          <TopBar />
        </div>
        <div
          style={{
            height: "calc(100vh - 80px)",
            width: "100%",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
